import { enabledModulesAccess } from "utils/modules-access";

export const PrivateModule = ({
  children,
  modules
}: {
  children: JSX.Element;
  modules: string[];
}) => {
  const enabled = enabledModulesAccess(modules);
  if (enabled) return children;
  return null;
};
